import globalDevMappings from './content-slot-mappings-global-dev';
import globalDevThMappings from './content-slot-mappings-global-dev-th';
import latamProdMappings from './content-slot-mappings-latam-prod';
import latamQAMappings from './content-slot-mappings-latam-qa';
import latamUATMmappings from './content-slot-mappings-latam-uat';
import thaProdMappings from './content-slot-mappings-tha-prod';
import thaQAMappings from './content-slot-mappings-tha-qa';
import thaUATMappings from './content-slot-mappings-tha-uat';
import defaultMappings from './content-slot-mappings';
import { Countries, DeploymentEnvironments } from 'common/types/enums';
import getTenantAndEnvKey from 'utils/getTenantAndEnvKey';

const combinedMappings = {
  [DeploymentEnvironments.GLOBAL_DEV]: globalDevMappings,
  [`${DeploymentEnvironments.GLOBAL_DEV}-${Countries.TH}`]: globalDevThMappings,
  [DeploymentEnvironments.THA_QA]: thaQAMappings,
  [DeploymentEnvironments.THA_UAT]: thaUATMappings,
  [DeploymentEnvironments.THA_PROD]: thaProdMappings,
  [DeploymentEnvironments.LATAM_QA]: latamQAMappings,
  [DeploymentEnvironments.LATAM_UAT]: latamUATMmappings,
  [DeploymentEnvironments.LATAM_PROD]: latamProdMappings,
};

const getResolvedContentSlotMapping = (country?: string) => {
  const key = getTenantAndEnvKey();

  if (country) {
    const countryKey = `${key}-${country}`;
    if (countryKey in combinedMappings) {
      return combinedMappings[countryKey as keyof typeof combinedMappings];
    }
  }

  if (key in combinedMappings) {
    return combinedMappings[key as DeploymentEnvironments];
  } else {
    return defaultMappings;
  }
};

export default getResolvedContentSlotMapping;
